/* eslint no-use-before-define: ["error", { "variables": false }] */

import PropTypes from 'prop-types';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native-web';

import moment from 'moment';

import Color from './Color';
import { TIME_FORMAT } from './Constant';

//gt: need to deal with locale later, for the purpose of rendering date/time
export default function Time({
  position = 'left',
  containerStyle = {},
  currentMessage = {
    createdAt: null
  },
  timeFormat = TIME_FORMAT,
  textStyle = {},
  timeTextStyle = {}
}) {
  return (
    <View style={[styles[position].container, containerStyle[position]]}>
      <Text style={[styles[position].text, textStyle[position], timeTextStyle[position]]}>
        {moment(currentMessage.createdAt)
          //.locale(context.getLocale())
          .locale('en')
          .format(timeFormat)}
      </Text>
    </View>
  );
}

const containerStyle = {
  marginLeft: 10,
  marginRight: 10,
  marginBottom: 5
};

const textStyle = {
  fontSize: 10,
  backgroundColor: 'transparent',
  textAlign: 'right',
  fontWeight: 600
};

const styles = {
  left: StyleSheet.create({
    container: {
      ...containerStyle
    },
    text: {
      color: Color.timeTextColor,
      ...textStyle
    }
  }),
  right: StyleSheet.create({
    container: {
      ...containerStyle
    },
    text: {
      color: Color.timeTextColor,
      ...textStyle
    }
  })
};

// Removed contextTypes - not used (getLocale is commented out)
// Time.contextTypes = {
//   getLocale: PropTypes.func
// };

// Removed defaultProps - using default parameters instead
// Time.defaultProps = {
//   position: 'left',
//   currentMessage: {
//     createdAt: null
//   },
//   containerStyle: {},
//   textStyle: {},
//   timeFormat: TIME_FORMAT,
//   timeTextStyle: {}
// };

Time.propTypes = {
  position: PropTypes.oneOf(['left', 'right']),
  currentMessage: PropTypes.object,
  /*
  containerStyle: PropTypes.shape({
    left: ViewPropTypes.style,
    right: ViewPropTypes.style,
  }),
  */
  timeFormat: PropTypes.string
  /*
  textStyle: PropTypes.shape({
    left: Text.propTypes.style,
    right: Text.propTypes.style,
  }),
  timeTextStyle: PropTypes.shape({
    left: Text.propTypes.style,
    right: Text.propTypes.style,
  }),
  */
};
